import LedgerEntry from "./LedgerEntry.js";
import Model from "./Model.js";

/**
 * One item of an account statement.
 *
 * @param {number} spec.amount - Value involved in the transaction
 * @param {number} spec.balance - Value of the balance for the transaction
 * @param {number} spec.credit - Value of the credit balance for the transaction
 * @param {number} spec.debit - Value of the debit balance for the transaction
 * @param {Date} spec.date - Date at which the transaction occurred
 * @param {string[]} spec.dimensions - dimensions involved for the transaction
 * @param {string} spec.text - Description of the transaction
 * @param {ledgerEntry} spec.ledgerEntry - Ledger entry attached to the transaction
 */
export default class AccountStatementItem extends Model {
	constructor(spec = {}) {
		super(spec);
		this._amount = spec.amount;
		this._balance = spec.balance;
		this._credit = spec.credit;
		this._debit = spec.debit;
		this._date = spec.date;
		this._dimensions = spec.dimensions;
		this._text = spec.text;
		this._ledgerEntry = spec.ledgerEntry;
	}

	getBalance() {
		return this._balance;
	}

	getLedgerEntry() {
		return this._ledgerEntry;
	}

	getAmount() {
		return this._amount;
	}

	getCredit() {
		return this._credit;
	}

	getDebit() {
		return this._debit;
	}

	getDate() {
		return this._date;
	}

	getDimensions() {
		return this._dimensions;
	}

	getText() {
		return this._text;
	}

	haveDimensions() {
		return this.getDimensions().length > 0;
	}

	getReversedCredit() {
		return this._reverse(this.getCredit());
	}

	_reverse(amount) {
		return 0 - amount;
	}

	static transformMaterializationData(data, context) {
		super.transformMaterializationData(...arguments);

		data.date = new Date(data.date);
		data.ledgerEntry = LedgerEntry.materialize(data.ledgerEntry);

		const dimensionTree = context.getFiscalYear().getDimensionTree();

		data.dimensions = data.dimensionIds.map((dimensionId) =>
			dimensionTree.findById(dimensionId),
		);
	}
}
